module.exports = __webpack_public_path__ + "img/New-Project.0caf7d3e.png";